import { useNavigate } from 'react-router-dom'
import { Avatar } from '@dhl/components'
import { Stack } from '@dhl-ui/components'
import { Language } from '@dhl/i18n'
import { Page } from '@dhl-ui/page'
import { getProfileInitials, useProfile } from '@dhl/keycloak'
import { links } from '~/AppRoutes'
import { locales } from '~/i18n'

export const HeaderContent = () => {
  const { data: profile } = useProfile()
  const navigate = useNavigate()

  return (
    <Page.Header
      endNode={
        <Stack direction="row" gap={1} alignItems="center">
          <Language locales={locales()} />
          <Avatar onClick={() => navigate(links.profileOverviewLink())} data-testid="link-button">
            {profile && getProfileInitials(profile)}
          </Avatar>
        </Stack>
      }
    />
  )
}
